import React from 'react';
import { FaCog } from 'react-icons/fa';


export function SpinCog({ title }: { title: string; }) {
    return <FaCog size="25px" className="w3-spin" title={title} />;
}
